import effectManager from '../effect';

let effect;

/* ---------------------------------------

    -- スクロール位置で発火するやつはここ

--------------------------------------- */
export default class ScrollAnimation{
    constructor(inc){

        effect = new effectManager();

        this.$container;
        this.$target;
        this.scPoint = [];
        this.scNumStart = 0;
        this.scNum;

        this.status = {
            init : false,
            comp : false /* 全部処理が終わったか */
        }

        this.conf = {
            page : ["top","stance"] /* 対象のページを記入 */
        }

        this.h;

    }
    init(pageID){


        if(this.conf.page.indexOf(pageID)>=0){
            this.status.init = true;
            this.scPoint = [];
            this.scNumStart = 0;
            this.$container = document.getElementById(pageID)
            this.$target = this.$container.querySelectorAll('.js__tsc');
            this.scNum = this.$target.length;
            effect.splitTextSimple(this.$container.querySelectorAll('.js__tsc-split'),"set");

            let _$svg = this.$container.querySelectorAll('.js__tsc-svg');

            for(let n in _$svg){
                if(_$svg[n].nodeType!=1) continue; // dom要素以外は処理止める
                effect.svgGlitch(_$svg[n],"set");
            }

            effect.panel(this.$container.querySelectorAll('.js__tsc-panel'),"set");
            effect.showSimple(this.$container.querySelectorAll('.js__tsc-show'),"set");
            this.resize(this.h)
        }else{
            this.status.init = false;
            TweenMax.set(document.querySelectorAll('.js__tsc-show'),{opacity:1})
        }

    }
    check(inc){

        if(!this.status.init) return;

        // console.log("$target",this.$target,this.$target[0])

        if(this.$target[0]){
            for(var i=this.scNumStart; this.scNum>i; i++){

                // console.log("point",this.scPoint[i],inc)
                if(this.scPoint[i] < inc  ) {

                    let $scp = this.$target[i];
                    // console.log("$scp",$scp,$scp.classList)
                    if($scp.classList===undefined) continue;
                    if($scp.classList[0].indexOf("is-show")==-1){
                        $scp.classList.add("is-show");
                        this.scNumStart += 1;

                        let _$svg = $scp.querySelectorAll(".js__tsc-svg");
                        let _$splitText = $scp.querySelectorAll(".js__tsc-split >* >*");
                        let _$show = $scp.querySelectorAll(".js__tsc-show");
                        let _$panel = $scp.querySelectorAll(".js__tsc-panel");
                        effect.svgGlitch(_$svg[0],"show",_$splitText,_$show,"short");

                        if(_$panel[0]) effect.panel(_$panel,"show");

                        // if(_$splitText[0]) effect.splitTextSimple(_$splitText,"show");
                        // if(_$show[0]) effect.showSimple(_$show,"show");

                        if(i==this.$target.length-1) this.status.comp = true;

                    }

                }

            }

        }

    }

    resize (winH) {

        if(!this.status.init) return;

        this.h = winH;

        if(this.$target){
            let _minusPoint = winH;
            this.scPoint = [];
            for( var i=this.scNumStart; i<this.scNum; i++) {

                let $scp = this.$target[i],
                    rect =  $scp.getBoundingClientRect();

                this.scPoint[i] = rect.top - _minusPoint;
            }
        }

    }
}